import { createSlice } from '@reduxjs/toolkit'

import { sessionApi } from '../api/sessionApi'
import { User } from './types'

type SessionSliceState =
  | {
      accessToken: string
      user: User
      isAuthorized: true
      loading: false
      isFetching: boolean
    }
  | {
      isAuthorized: false
      accessToken?: string | null
      user?: User | null
      loading: boolean
      isFetching: boolean
    }

const initialState: SessionSliceState = {
  isAuthorized: false,
  user: null,
  accessToken: null,
  loading: false,
  isFetching: false,
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    clearSessionData: state => {
      state.accessToken = undefined
      state.user = undefined
      state.isAuthorized = false
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      sessionApi.endpoints.sendOtp.matchPending,
      (state: SessionSliceState, { payload }) => {
        state.loading = true
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.sendOtp.matchFulfilled,
      (state: SessionSliceState, { payload }) => {
        state.isAuthorized = true
        state.loading = false
        if (state.isAuthorized) {
          state.accessToken = payload.accessToken
        }
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.sendOtp.matchRejected,
      (state: SessionSliceState, { payload }) => {
        state.loading = false
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.login.matchFulfilled,
      (state: SessionSliceState, { payload }) => {
        state.isAuthorized = false
        state.accessToken = payload.access_token
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.logout.matchPending,
      (state: SessionSliceState) => {
        state.isAuthorized = false
        state.loading = true
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.logout.matchFulfilled,
      (state: SessionSliceState) => {
        localStorage.setItem('persist:root', '')
        state.isAuthorized = false
        state.accessToken = null
        state.user = null
        // window.location.href = '/login'
        state.loading = false
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.logout.matchRejected,
      (state: SessionSliceState) => {
        state.isAuthorized = false
        state.loading = false
      },
    )

    builder.addMatcher(
      sessionApi.endpoints.me.matchPending,
      (state: SessionSliceState, { payload }) => {
        state.isFetching = true
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.me.matchFulfilled,
      (state: SessionSliceState, { payload }) => {
        if (state.isAuthorized) {
          state.user = payload
          state.isFetching = false
        }
      },
    )
    builder.addMatcher(
      sessionApi.endpoints.me.matchRejected,
      (state: SessionSliceState, { payload }) => {
        state.isFetching = false
      },
    )
  },
})

export const selectIsAuthorized = (state: RootState) =>
  state.session.isAuthorized

export const selectIsAuthLoading = (state: RootState) =>
  state.session.loading || state.session.isFetching

export const selectUserMe = (state: RootState): User => state.session.user

export const { clearSessionData } = sessionSlice.actions
